import React, { useState, useEffect } from "react"
import { Dialog, DialogActions, DialogContent, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import WorkflowForm from "./WorkflowForm";

export default function WorkflowFormDialog(props) {
    return (
        <Dialog open={props.open}>
            <DialogActions>
                <IconButton
                    aria-label="close"
                    color="inherit"
                    sx={{ p: 0.25 }}
                    onClick={props.handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogActions>
            <DialogContent sx={{ paddingTop: 0 }}>
                <WorkflowForm {...props} handleClose={props.handleClose} />
            </DialogContent>
        </Dialog>
    );
};